var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-page-header',{staticClass:"klook-page-title page-content",attrs:{"title":_vm.title}},[_c('template',{slot:"extra"},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }